module.exports = __webpack_public_path__ + "static/media/triple-standard-img1.db7c5e1a.jpg";